import {PolIcon} from "components/PolIcon/policon";
import React, {useEffect, useMemo} from 'react';
import {Link, useHistory} from "react-router-dom";
import ReactTooltip from "react-tooltip";
import PolPopup from "v4/components/ui/PolPopup/PolPopup";
import {MAILING_SEND} from "v4/data/apiRoutes";
import {PROSPECT} from "v4/data/entities";
import CampaignPopup from "v4/features/front/campaign/components/CampaignPopup/CampaignPopup";
import ListingExport from "v4/features/front/export/components/ListingExport/ListingExport";
import {useNavigation} from "v4/features/front/navigation/contexts/NavigationContext";
import SearchLinkedEntitiesList from "v4/features/front/searchLinkedEntities/components/searchLinkedEntitiesList";
import useFetch from "v4/hooks/useFetch";
import {usePolTranslation} from "v4/hooks/usePolTranslation";
import useToggle from "v4/hooks/useToggle";
import {generateUrl} from "v4/services/api.service";
import CampaignVoter from "v4/voters/campaignVoter";
import ModuleStatisticsVoter from "v4/voters/moduleStatisticsVoter";

export default function ProspectsListingTools({alternativeListing, checkedRows}) {
    const {t} = usePolTranslation();
    const {replace} = useHistory();
    const {currentRoute, getRouteByNativeIdentifier} = useNavigation();
    const prospectRoute = getRouteByNativeIdentifier('main_prospects');
    const [{data, isLoading}, fetchMailing] = useFetch();
    const {canCreateCampaign} = CampaignVoter();
    const {canAccessModuleStatistics} = ModuleStatisticsVoter();
    const [showCampaignPopup, toggleShowCampaignPopup] = useToggle();

    const isListingEnabled = checkedRows?.length > 0;

    const alternatives = useMemo(() => ([
        {
            id: 'maps',
            icon: 'map',
            tooltip: 'map_display',
            voter: () => true
        },
        {
            id: 'statistics',
            icon: 'calculator',
            tooltip: 'stats_display',
            voter: canAccessModuleStatistics
        }
    ]), [canAccessModuleStatistics]);

    const handleMailing = () => {
        fetchMailing({
            url: generateUrl(MAILING_SEND),
            config: {
                method: 'POST',
                body: JSON.stringify({
                    type: `${PROSPECT}s`, /* TODO: changer prospects en prospect côté back */
                    value: checkedRows
                })
            }
        })
    }

    useEffect(() => {
        if (!data?.success) return;

        const emailingRoute = getRouteByNativeIdentifier('main_newsletter_emailing');

        if (!emailingRoute) return;

        replace(`/${emailingRoute.url}`);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    const allowedAlternatives = currentRoute?.routeConfig?.alternatives || [];

    return (
        <>
            {alternatives
                .filter(alt => allowedAlternatives.includes(alt.id) && alt.voter())
                .map(alt => {
                    const isActive = alternativeListing === alt.id;
                    return (
                        <li key={alt.id}
                            className="listing-header__action"
                            data-for="listing-tooltip"
                            data-tip={t(isActive ? 'lines_display' : alt.tooltip)}>
                            <Link to={isActive ? `/${prospectRoute?.url}` : `/${prospectRoute?.url}/${alt.id}`}>
                                <PolIcon icon={isActive ? 'list' : alt.icon} className={isActive ? '' : 'action__picto'}/>
                            </Link>
                        </li>
                    );
                })
            }
            <ReactTooltip id="listing-tooltip" effect="solid"/>

            <ListingExport selectedItems={checkedRows} entity={PROSPECT}/>


            <li className="listing-header__action dropdown">
                <PolIcon icon="actions"
                         className="action__picto action__dropdown__Btn"/>
                <ul className="listing-header__action__dropdown">
                    <li className={`listing-header__action__item ${(!isListingEnabled || isLoading) ? 'listing-header__action__item__disabled' : ''}`}
                        onClick={handleMailing}>
                        <p>{t('send_emailing')}</p>
                        {isLoading && <PolIcon icon="circle-notch" className="spinner"/>}
                    </li>

                    {
                        canCreateCampaign() && (
                            <>
                                <li className={`listing-header__action__item${checkedRows.length > 0 ? '' : ' listing-header__action__item__disabled'}`}
                                    onClick={toggleShowCampaignPopup}>
                                    <p>{t("send_campaign")}</p>
                                </li>
                                <PolPopup isOpen={showCampaignPopup}
                                          closePopup={toggleShowCampaignPopup}
                                          title={t('create_campaign')}>
                                    <CampaignPopup selectedIds={checkedRows}
                                                   type="prospects"
                                                   toggleShow={toggleShowCampaignPopup}/>
                                </PolPopup>
                            </>
                        )
                    }

                    <SearchLinkedEntitiesList entity={PROSPECT} checkedRows={checkedRows}/>
                </ul>
            </li>
        </>
    )
}
